import { render } from "./SelectVariantModal.vue?vue&type=template&id=33f0bb1c"
import script from "./SelectVariantModal.vue?vue&type=script&lang=js"
export * from "./SelectVariantModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/WIMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__